import { useNavigate } from "@tanstack/react-router";
import { Button } from "../../../ui/button/button";
import { CardSVG } from "../../../ui/icons";

const ConnectAccountCard: React.FC = () => {
	const navigate = useNavigate();
	return (
		<div className="p-4 bg-primary-50 rounded-3xl">
			<div className="flex flex-col items-center mb-4">
				<CardSVG />
				<h2 className="text-2xl font-bold text-textDark leading-[34px]">
					Connect an account
				</h2>
				<p className="text-sm font-medium text-textDark w-[65%] text-center mt-1 leading-6">
					Link an account to securely transfer your funds.
				</p>
			</div>
			<Button
				className="w-full mt-6 text-base font-bold text-white bg-primary-600 rounded-xl"
				size={"lg"}
				onClick={() => {
					navigate({ to: "/main/setting/linked-accounts/new" });
				}}
			>
				+ Connect account
			</Button>
		</div>
	);
};

export default ConnectAccountCard;
